<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="用户名" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getFilterList">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="default" @click="confirmUpdate=true">重置</el-button>
				</el-form-item>
				<el-form-item style="float:right">
					<el-button type="primary"  @click="addOpreaterFrom() ">添加运营</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<el-table :data="tableData" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column prop="id" label="ID" width="80">
			</el-table-column>
			<el-table-column prop="avatar" label="头像" width="100">
				<template slot-scope="image">
                    <img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
                 </template>
			</el-table-column>
			<el-table-column prop="nickName" label="登录名" width="200">
			</el-table-column>
			<el-table-column label="剩余金额" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleDetails(scope.$index, scope.row)">{{scope.row.remainder}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="卡券库" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleCoupons(scope.$index, scope.row)">{{scope.row.couponNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="作品数" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleWorks(scope.$index, scope.row)">{{scope.row.workNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120" class="button-bar" fixed='right'>
				<template slot-scope="scope">
					<el-button type="text"  size="small" @click="handleRelieve(scope.$index, scope.row)">解除认证</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination  background layout="total,prev, pager, next, jumper, sizes" @current-change="handleCurrentChange"
				@size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage"
				:page-size="pageSize" :total="totalNumber" style="float:left;">
			</el-pagination>
		</el-col>
		<el-dialog title="搜索用户添加为运营人员" :visible.sync="opreteSearchFormVisible" :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true">
					<el-form-item>
						<el-input v-model="searchName" placeholder="用户名" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-on:click="getOperateUser">查询</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-table :data="operateTableData" ref="operateSelect" highlight-current-row v-loading="operateLoading" style="width: 100%;height:300px;overflow:auto;">
				<el-table-column type="selection" width="80"></el-table-column>
				<el-table-column prop="id" label="ID" >
				</el-table-column>
				<el-table-column prop="avatar" label="头像" >
					<template slot-scope="image">
						<img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="登录名" >
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="opreteSearchFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addOperateUser()" :loading="chargeLoading">确定</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				loadingPass: false,
				loadingUnpass: false,
				checkVisible: false,
				currentId: null,
				chargeFormVisible: false,
				selcetedCheckState: null,
				selectedShelvesState: null,
				multipleSelection: [],
				totalNumber: null,
				tableData: null,
				pageSize: 10,
				currentPage: 1,
				shelvesState: [{ label: '付费', value: 'ON_SHELVES' }, { label: '普通', value: 'OFF_SHELVES' },],
				checkState: [{ label: '审核中', value: 'WAITING' }, { label: '审核通过', value: 'PASSED' }, { label: '不通过', value: 'REJECTED' }],
				filters: {
					name: ''
				},
				users: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入金额', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},
				chargeLoading: false,
				chargeForm: {
					money: 0,
				},
				confirmUpdate: false,
				opreteSearchFormVisible:false,
				searchName:"",
				operateLoading:false,
				operateTableData:null
			}
		},
		methods: {
			async setCheckState(index) {
				let state = 'WAITING'
				if (index == 0) {
					this.loadingUnpass = true;
					state = 'REJECTED'
				} else {
					this.loadingPass = true;
					state = 'PASSED'
				}
				try {
					let result = await this.$http.post(this,`/project/${this.currentId}/audit/${state}`);
					if (index == 0) {
						this.loadingUnpass = false;
					} else {
						this.loadingPass = false;
					}
					if (result && result.code == 200) {
						this.$message({
							message: '完成',
							type: 'success'
						});
						this.getList(this.currentPage - 1);
					}
				} catch (e) {
					this.loadingPass = false;
					this.loadingUnpass = false;
				}
				this.checkVisible = false;
			},
			handleSelectionChange(val) {
				console.log('checkb0x-', val)
				this.multipleSelection = val;
			},
			formatDatas(item) {
				return {
					id: item.id,
					avatar: item.avatar||'',
					remainder: item.remainder||0,
					nickName: item.nickname||item.username,
					workNum: item.workNum||0,
					couponNum:item.couponNum||0,
				};
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage - 1);
			},
			getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			async getList(index) {
				let condition = {}
				condition.userName = this.filters.name;
				condition.currentPage = index;
				condition.pageSize = this.pageSize;
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/operational/getOperationalUserList', {},condition);
					if (result && result.code == 200) {
						this.tableData = result.data.rows.map((item) => { return this.formatDatas(item) });
						this.totalNumber = result.data.total
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}
			},

			async getOperateUser(){
				try{
					if(this.searchName =='' || this.searchName == null){
						this.$message({
							type: 'error',
							message: '请输入用户名称'
						});  
						return;
					}
					this.operateLoading = true;
					let result = await this.$http.post(this,'/operational/getOperationalUserByname', { username: this.searchName},{});
					if (result && result.code == 200) {
						this.operateTableData = result.data;
						this.operateLoading = false;
					}
				} catch(e){
					this.operateLoading = false;
				}
			},

			handleRelieve: function (index, row) {
				this.currentId = row.id;
				this.chargeFormVisible = true;
				this.$confirm('运营成员拥有使用商户托管卡券的权利，请确认是否解除运营人员身份认证。', '删除运营成员', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteUserFromOper();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});          
				});

			},

			async deleteUserFromOper(){
				try{
					let condition ={};
					condition.userId = this.currentId;
					let result =  await this.$http.post(this,'/operational/deleteUserFromOper', {},condition);
					
					if (result && result.code == 200) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getList(0);
					}
				} catch(e){
					this.operateLoading = false;
				}
			},
			handleWorks(index, row)  {
				this.$router.push({ path: '/operateManage/works', query: { userid: row.id } });
			},
			handleDetails(index,row){
				this.$router.push({ path: '/operateManage/details', query: { userId: row.id,userName: row.nickName } });
			},
			handleCoupons(index, row)  {
				this.$router.push({ path: '/operateManage/coupon', query: { userName:row.nickName,userId: row.id,avatar:row.avatar,couponNum:row.couponNum } });
			},
			handleCheck: function (index, row) {
				this.checkVisible = true;
				this.currentId = row.id;
			},
			addOpreaterFrom(){
 				this.opreteSearchFormVisible=true
			},
			addOperateUser(){
				let _this = this;
				let selectData = _this.$refs.operateSelect.selection;
				if (selectData === undefined || selectData.length ==0){
					_this.$message({
								message: '请选择运营人员!',
								type: 'fail'
							});
					return
				} else {
					_this.$confirm('运营成员拥有使用商户托管卡券的权利，请确认当前用户为先脑科技运营人员', '添加运营成员', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let userList = [];
						for (var i=0;i<selectData.length;i++) {
							userList.push(selectData[i].id);
						}
						_this.addUser(userList);
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});          
					});
				}					
			},
			async addUser(userList){
				let condition = {};
				condition.userList = userList;
				try{
					let result = await this.$http.post(this,'/operational/updateUserToOper', {},condition);
					if (result && result.code == 200) {
						this.$message({
							type: 'success',
							message: '添加运营人员成功!'
						});
						this.opreteSearchFormVisible =false;
						this.getList(0);
					}
				} catch(e){
					this.opreteSearchFormVisible =false;
				}
			},
		},
		mounted() {
			this.getList(0);
		}
	}

</script>

<style scoped>
	.el-button+.el-button {
		margin-left: 4px;
	}

	.el-button--small,
	.el-button--small.is-round {
		padding: 8px 10px;
	}

	.el-button--text {
		padding-left: 0;
		padding-right: 0;
	}
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.comf-btn {
		display: flex;
		justify-content: flex-end;
	}
</style>
